import { render, staticRenderFns } from "./EnslavedTab.vue?vue&type=template&id=b60b5b32&scoped=true"
import script from "./EnslavedTab.vue?vue&type=script&lang=js"
export * from "./EnslavedTab.vue?vue&type=script&lang=js"
import style0 from "./EnslavedTab.vue?vue&type=style&index=0&id=b60b5b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60b5b32",
  null
  
)

export default component.exports